import { CCardHeader } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarCardHeader = (props) => {
  const { children } = props
  return <CCardHeader {...props}>{children}</CCardHeader>
}

export { ConfiaCarCardHeader }
